import React from 'react';
import PropTypes from 'prop-types';

export function SvgClock({ width = 16, height = 16, stroke = '#000000' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd" stroke="none" strokeLinejoin="round" strokeWidth="1">
        <g stroke={stroke} strokeWidth="2" transform="translate(-117 -716)">
          <g transform="translate(113 712)">
            <g>
              <path d="M12 18.667a6.667 6.667 0 100-13.334 6.667 6.667 0 000 13.334zM12 8v4l2.667 1.333" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

SvgClock.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
